import ApiFabric from "@libs/api/ApiFabric";
import * as api from "./ApiExportHelper";

class ServicesApiFabric extends ApiFabric {
  constructor() {
    super();
    this.setValidInstances(api);
  }
}
let fabric = new ServicesApiFabric();
export default fabric;
